export const API_GET_REASSIGNMENT_LOGS = "API_GET_REASSIGNMENT_LOGS"
export const RESET_REASSIGNMENT_LOGS = "RESET_REASSIGNMENT_LOGS"
